import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
    public transform(value: string, limit: number = 20, trail: string = '...'): string {
        if (!value) return '';

        return value.length > limit ? value?.substring(0, limit)?.trim() + trail : value;
    }
}
